<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">

    <button pButton pRipple type="button" icon="fa fa-angle-down" [label]="'ADMIN.COMMON.ACTIONS' | translate" iconPos="right"
        class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
        (click)="action.toggle($event)" *ngIf="showActions($.row)"
        data-testid="transfer-actions-button" aria-label="transfer-actions-button">
    </button>
    <p-popover #action styleClass="overflow-hidden text-sm w-10rem -ml-5" data-testid="transfer-actions-panel" aria-label="transfer-actions-panel">
        <ng-template #content>
            <ul class="list-none -m-4 py-2 px-0 text-xs text-600" data-testid="transfer-actions-list">

                <li *ngIf="$.adata.includes('DeclineTransfer') && ShowDecline($.row)"
                    (click)=" executeAction('declinetransfer',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                    data-testid="decline-transfer-action" aria-label="decline-transfer-action">
                    <i class="fa fa-times text-xl-circle mr-3 text-600"></i> {{ 'ADMIN.COMMON.DECLINE_TRANSFER' | translate }}
                </li>

                <li *ngIf="$.adata.includes('StartTransfer') && ShowStart($.row)"
                    (click)=" executeAction('starttransfer',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                    data-testid="start-transfer-action" aria-label="start-transfer-action">
                    <i class="fa fa-arrows-h mr-3 text-600"></i> {{ 'ADMIN.COMMON.START_TRANSFER' | translate }}
                </li>

                <li *ngIf="$.adata.includes('VoidTransfer') && ShowVoid($.row)"
                    (click)=" executeAction('voidtransfer',$.row,action)"
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                    data-testid="void-transfer-action" aria-label="void-transfer-action">
                    <i class="fa fa-minus-circle mr-3 text-600"></i> {{ 'ADMIN.COMMON.VOID_TRANSFER' | translate }}
                </li>
            </ul>
        </ng-template>
    </p-popover>
</ng-container>